"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
var ZERO_WIDTH_SPACE = '&#8203;';
var UNWRAPPABLE_NODES = 'LI,THEAD,TBODY,TR,TD,TH'.split(',');
var DEFAULT_STYLER = function (_) { };
/**
 * Toggle a tag at selection, if selection already contains elements of such tag,
 * the elements will be untagge and other elements will take no affect
 * @param editor The editor instance
 * @param tag The tag name
 * @param styler (Optional) The styler for setting the style for the blockquote element
 * @param wrapFunction (Optional) The wrap function
 * @param unwrapFunction (Optional) The unwrap function
 */
function toggleTagCore(editor, tag, styler, wrapFunction, unwrapFunction) {
    if (wrapFunction === void 0) { wrapFunction = function (nodes) { return roosterjs_editor_dom_1.wrap(nodes, tag); }; }
    if (unwrapFunction === void 0) { unwrapFunction = roosterjs_editor_dom_1.unwrap; }
    editor.focus();
    editor.addUndoSnapshot(function (start, end) {
        var result;
        var range = editor.getSelectionRange();
        if (range &&
            editor.queryElements(tag, 1 /* OnSelection */, unwrapFunction).length == 0) {
            var startNode = roosterjs_editor_dom_1.Position.getStart(range).normalize().node;
            var startBlock = editor.getBlockElementAtNode(startNode);
            var endNode = roosterjs_editor_dom_1.Position.getEnd(range).normalize().node;
            var endBlock = editor.getBlockElementAtNode(endNode);
            var nodes = startBlock && endBlock
                ? editor.collapseNodes(startBlock.getStartNode(), endBlock.getEndNode(), true /*canSplitParent*/)
                : [];
            if (nodes.length == 0) {
                // Selection is collapsed and blockElement is null, we need to create an empty div.
                // In case of IE and Edge, we insert ZWS to put cursor in the div, otherwise insert BR node.
                nodes = roosterjs_editor_dom_1.fromHtml("<DIV>" + (roosterjs_editor_dom_1.Browser.isIEOrEdge ? ZERO_WIDTH_SPACE : '<BR>') + "</DIV>", editor.getDocument());
                editor.insertNode(nodes[0]);
                editor.select(nodes[0], 0 /* Begin */);
            }
            else if (nodes.length == 1) {
                var tag_1 = roosterjs_editor_dom_1.getTagOfNode(nodes[0]);
                if (tag_1 == 'BR') {
                    nodes = [roosterjs_editor_dom_1.wrap(nodes[0])];
                }
                else if (tag_1 == 'LI' || tag_1 == 'TD') {
                    nodes = roosterjs_editor_dom_1.toArray(nodes[0].childNodes);
                }
            }
            else {
                while (nodes[0] &&
                    editor.contains(nodes[0].parentNode) &&
                    nodes.some(function (node) { return UNWRAPPABLE_NODES.indexOf(roosterjs_editor_dom_1.getTagOfNode(node)) >= 0; })) {
                    nodes = [roosterjs_editor_dom_1.splitBalancedNodeRange(nodes)];
                }
            }
            result = wrapFunction(nodes);
            (styler || DEFAULT_STYLER)(result);
        }
        if (!editor.select(start, end) && result) {
            editor.select(result);
        }
        return result;
    }, "Format" /* Format */);
}
exports.default = toggleTagCore;
//# sourceMappingURL=toggleTagCore.js.map